import { pxToRem } from '../../../../utils';
export default (function (siteVars) {
  return {
    margin: '0',
    padding: "".concat(pxToRem(7), " ").concat(pxToRem(12)),
    borderColor: 'transparent',
    borderRadius: "".concat(pxToRem(3), " ").concat(pxToRem(3), " ").concat(pxToRem(2), " ").concat(pxToRem(2)),
    borderWidth: "0 0 ".concat(pxToRem(2), " 0"),
    backgroundColor: siteVars.colorScheme["default"].background2,
    invertedBackgroundColor: siteVars.colorScheme["default"].background,
    placeholderColor: siteVars.colorScheme["default"].foreground1,
    disabledBackgroundColor: siteVars.colorScheme["default"].backgroundColorDisabled,
    disabledColor: siteVars.colorScheme["default"].colorDisabled,
    fontColor: siteVars.colorScheme["default"].foreground,
    fontSize: siteVars.fontSizes.medium,
    borderColorFocus: "transparent transparent ".concat(siteVars.colorScheme.brand.borderFocus1, " transparent"),
    height: 'auto'
  };
});